var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSearchGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1543 22.0596L20.1543 20.0596M11.6543 21.0596C12.9019 21.0596 14.1372 20.8138 15.2898 20.3364C16.4424 19.859 17.4897 19.1592 18.3718 18.2771C19.254 17.3949 19.9537 16.3477 20.4312 15.1951C20.9086 14.0425 21.1543 12.8071 21.1543 11.5596C21.1543 10.312 20.9086 9.07667 20.4312 7.92408C19.9537 6.77148 19.254 5.72421 18.3718 4.84206C17.4897 3.9599 16.4424 3.26013 15.2898 2.78271C14.1372 2.30529 12.9019 2.05957 11.6543 2.05957C9.13474 2.05957 6.71838 3.06046 4.93678 4.84206C3.15519 6.62365 2.1543 9.04001 2.1543 11.5596C2.1543 14.0791 3.15519 16.4955 4.93678 18.2771C6.71838 20.0587 9.13474 21.0596 11.6543 21.0596Z",
    stroke: "#f9bc03",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchGreen);
export default __webpack_public_path__ + "static/media/ic_search_green.c52d9eccb46659a0624fa8ca73877adb.svg";
export { ForwardRef as ReactComponent };